import {
	FETCH_CHAT_USERS_REQUEST,
	FETCH_CHAT_USERS_SUCCESS,
	FETCH_CHAT_USERS_FAILURE
} from "../../constants";

const initialState = {
	data: [],
	loading: false,
	error: null,
};

const pharmacyChatListReducer = (state = initialState, action) => {
	switch (action.type) {
		case FETCH_CHAT_USERS_REQUEST:
			return {
				...state,
				loading: true,
				error: null
			};
		case FETCH_CHAT_USERS_SUCCESS:
			return {
				...state,
				loading: false,
				data: action.payload,
				error: null,
			};
		case FETCH_CHAT_USERS_FAILURE:
			return {
				...state,
				loading: false,
				data: [],
				error: action.payload,
			};
		default:
			return state;
	}
}

export default pharmacyChatListReducer;
